<template>
  <section>
    <b-modal id="details-modal" size="xl" title="Solicitação" scrollable centered no-enforce-focus>
      <div class="modal-log">
        <fieldset 
          class="made-up" 
          v-if="
            this.getlogchat.type ||
            this.getlogchat.assunto ||
            this.getlogchat.motivo ||
            this.getlogchat.channel ||
            this.getlogchat.cidade ||
            this.getlogchat.solicitacaoData ||
            this.getlogchat.solicitacaoHora || 
            this.getlogchat.placa || 
            this.getlogchat.placaSolicitante || 
            this.getlogchat.prefixo || 
            this.getlogchat.sufixo || 
            this.getlogchat.nomeBase || 
            this.getlogchat.siglaBase || 
            this.getlogchat.solicitacaoAssunto || 
            this.getlogchat.solicitacaoTexto
          "
        >
          <legend>Solicitação</legend>
          <div class="row">
            <div class="col-md-12 espcForm" v-if="this.getlogchat.type">
              <label for="type"><strong>Tipo</strong></label>
              <input class="form-control" v-model="this.getlogchat.type" type="text" id="type" name="type" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.assunto">
              <label for="assunto"><strong>Assunto</strong></label>
              <input class="form-control" v-model="this.getlogchat.assunto" type="text" id="assunto" name="assunto" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.motivo">
              <label for="motivo"><strong>Motivo de Acionamento</strong></label>
              <input class="form-control" v-model="this.getlogchat.motivo" type="text" id="motivo" name="motivo" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.channel">
              <label for="channel"><strong>Canal de Atendimento</strong></label>
              <input class="form-control" v-model="this.getlogchat.channel" type="text" id="channel" name="channel" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.solicitacaoData">
              <label for="solicitacaoData"><strong>Data</strong></label>
              <input class="form-control" v-model="this.getlogchat.solicitacaoData" type="text" id="solicitacaoData" name="solicitacaoData" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.solicitacaoHora">
              <label for="solicitacaoHora"><strong>Hora</strong></label>
              <input class="form-control" v-model="this.getlogchat.solicitacaoHora" type="text" id="solicitacaoHora" name="solicitacaoHora" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.placaSolicitante">
              <label for="placaSolicitante"><strong>Placa do Solicitante</strong></label>
              <input class="form-control" v-model="this.getlogchat.placaSolicitante" type="text" id="placaSolicitante" name="placaSolicitante" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.placa">
              <label for="placa"><strong>Placa do veículo</strong></label>
              <input class="form-control" v-model="this.getlogchat.placa" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.prefixo">
              <label for="prefixo"><strong>Prefixo</strong></label>
              <input class="form-control" v-model="this.getlogchat.prefixo" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.sufixo">
              <label for="sufixo"><strong>Sufixo</strong></label>
              <input class="form-control" v-model="this.getlogchat.sufixo" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.cidade">
              <label for="cidade"><strong>Cidade</strong></label>
              <input class="form-control" v-model="this.getlogchat.cidade" type="text" id="cidade" name="cidade" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.nomeBase">
              <label for="nomeBase"><strong>Nome da Base</strong></label>
              <input class="form-control" v-model="this.getlogchat.nomeBase" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.siglaBase">
              <label for="siglaBase"><strong>Sigla da Base</strong></label>
              <input class="form-control" v-model="this.getlogchat.siglaBase" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.texto">
              <label for="texto"><strong>Texto</strong></label>
              <div v-html="getlogchat.texto" class="fixed-height-input"></div>
            </div>
          </div>
        </fieldset>
        <fieldset 
          class="made-up" 
          v-if="
            this.getlogchat.nome || 
            this.getlogchat.contato || 
            this.getlogchat.cnpj || 
            this.getlogchat.chamado || 
            this.getlogchat.protocolo || 
            this.getlogchat.assunto || 
            this.getlogchat.created_at || 
            this.getlogchat.created_by || 
            this.getlogchat.motivo ||
            this.getlogchat.sector || 
            this.getlogchat.sla || 
            this.getlogchat.sla_att 
          "
        >
          <legend>Dados do Atendimento</legend>
          <div class="row">
            <div class="col-md-12 espcForm" v-if="this.getlogchat.nome">
              <label for="nome"><strong>Nome</strong></label>
              <input class="form-control" v-model="this.getlogchat.nome" type="text" id="nome" name="nome" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.contato">
              <label for="whatsapp"><strong>Telefone</strong></label>
              <input class="form-control" v-model="this.getlogchat.contato" type="text" id="whatsapp" name="whatsapp" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.cnpj">
              <label for="cnpj"><strong>CNPJ</strong></label>
              <input class="form-control" v-model="this.getlogchat.cnpj" type="text" id="cnpj" name="cnpj" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.chamado">
              <label for="chamado"><strong>Chamado</strong></label>
              <input class="form-control" v-model="this.getlogchat.chamado" type="text" id="chamado"
                name="chamado" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.protocolo">
              <label for="protocolo"><strong>Protocolo</strong></label>
              <input class="form-control" v-model="this.getlogchat.protocolo" type="text" id="protocolo"
                name="protocolo" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.sector">
              <label for="sector"><strong>Área Responsável</strong></label>
              <input class="form-control" v-model="this.getlogchat.sector" type="text" id="sector" name="sector"
                disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.sla">
              <label for="sla"><strong>SLA</strong></label>
              <input class="form-control" v-model="this.getlogchat.sla" type="text" id="sla" name="sla" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.sla_att">
              <label for="sla_att"><strong>Primeiro Atendimento</strong></label>
              <input class="form-control" v-model="this.getlogchat.sla_att" type="text" id="sla_att" name="sla_att" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.created_at">
              <label for="created_at"><strong>Data de Criação</strong></label>
              <input class="form-control" v-model="this.getlogchat.created_at" type="text" id="created_at"
                name="created_at" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.created_by">
              <label for="created_by"><strong>Criado por</strong></label>
              <input class="form-control" v-model="this.getlogchat.created_by" type="text" id="created_by"
                name="created_by" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.updated_at">
              <label for="updated_at"><strong>Data de Alteração</strong></label>
              <input class="form-control" v-model="this.getlogchat.updated_at" type="text" id="updated_at"
                name="updated_at" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.updated_by">
              <label for="updated_by"><strong>Alterado por</strong></label>
              <input class="form-control" v-model="this.getlogchat.updated_by" type="text" id="updated_by"
                name="updated_by" disabled>
            </div>
          </div>
        </fieldset>
        <fieldset 
          class="made-up" 
          v-if="
            this.getlogchat.NomeCliente || 
            this.getlogchat.cnpj || 
            this.getlogchat.nomePonto || 
            this.getlogchat.codigoPonto || 
            this.getlogchat.endereco || 
            this.getlogchat.cep
          "
        >
        <legend>Dados da Base</legend>
        <div class="row">
          <div class="col-md-12 espcForm" v-if="this.getlogchat.NomeCliente">
            <label for="NomeCliente"><strong>Cliente</strong></label>
            <input class="form-control" v-model="this.getlogchat.NomeCliente" type="text" id="NomeCliente" name="NomeCliente" disabled>
          </div>
          <div class="col-md-12 espcForm" v-if="this.getlogchat.nomePonto">
            <label for="nomePonto"><strong>Nome do Ponto</strong></label>
            <input class="form-control" v-model="this.getlogchat.nomePonto" type="text" id="nomePonto" name="nomePonto" disabled>
          </div>
          <div class="col-md-12 espcForm" v-if="this.getlogchat.codigoPonto">
            <label for="codigoPonto"><strong>Código do Ponto</strong></label>
            <input class="form-control" v-model="this.getlogchat.codigoPonto" type="text" id="codigoPonto" name="codigoPonto" disabled>
          </div>
          <div class="col-md-12 espcForm" v-if="this.getlogchat.Base">
            <label for="base"><strong>Base</strong></label>
            <input class="form-control" v-model="this.getlogchat.Base" type="text" id="base" name="base" disabled>
          </div>
          <div class="col-md-12 espcForm" v-if="this.getlogchat.endereco">
            <label for="endereco"><strong>Endereço</strong></label>
            <input class="form-control" v-model="this.getlogchat.endereco" type="text" id="endereco" name="endereco" disabled>
          </div>
          <div class="col-md-12 espcForm" v-if="this.getlogchat.cep">
            <label for="cep"><strong>CEP</strong></label>
            <input class="form-control" v-model="this.getlogchat.cep" type="text" id="cep" name="cep" disabled>
          </div>
        </div>
      </fieldset>
      <fieldset class="made-up avoid-page-break" v-if="hasProcedureDeviation">
        <legend>Desvio de Procedimento</legend>
        <div class="row">
          <div class="col-md-12" v-if="getlogchat.procedure_deviation.updated_by">
            <label for="procedureDeviationBy"><strong>Registrado por</strong></label>
            <input class="form-control" :value="getlogchat.procedure_deviation.updated_by" type="text" id="procedureDeviationBy" disabled>
          </div>
          <div class="col-md-12 espcForm" v-if="getlogchat.procedure_deviation.updated_at">
            <label for="procedureDeviationAt"><strong>Data do registro</strong></label>
            <input class="form-control" :value="moment(getlogchat.procedure_deviation.updated_at).format('DD/MM/YYYY HH:mm:ss')" type="text" id="procedureDeviationAt" disabled>
          </div>
          <div class="col-md-12 espcForm">
            <label for="procedureDeviationJustification"><strong>Justificativa</strong></label>
            <div class="form-control html-input" id="procedureDeviationJustification" style="height: auto; white-space: pre-wrap; word-break: break-word;">{{ getlogchat.procedure_deviation.justification || '---' }}</div>
          </div>
        </div>
      </fieldset>
      <fieldset class="made-up avoid-page-break" v-if="this.getlogchat && this.getlogchat.feedback && Object.keys(this.getlogchat.feedback).length">
        <legend>Feedback</legend>
        <div class="row">
          <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.updated_by">
            <label for="userName"><strong>Enviado por</strong></label>
            <input class="form-control" v-model="this.getlogchat.feedback.updated_by" type="text" id="userName" name="userName" disabled>
          </div>
          <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.updated_at">
            <label for="nomePonto"><strong>Data de envio</strong></label>
            <input class="form-control" v-model="this.getlogchat.feedback.updated_at" type="text" id="nomePonto" name="nomePonto" disabled>
          </div>
          <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.message">
            <label for="codigoPonto"><strong>Mensagem</strong></label>
            <div class="form-control html-input" style="height: auto" v-html="this.getlogchat.feedback.message" type="text" disabled></div>
          </div>
        </div>
      </fieldset>
      <fieldset class="made-up avoid-page-break" v-if="this.getlogchat && this.getlogchat.notes && this.getlogchat.notes.length">
        <legend>Anotações</legend>
        <div class="notes-container">
          <div v-for="(note, noteIndex) in getlogchat.notes" :key="`${note.created_at}-${noteIndex}`" class="note-item">
            <span>{{ note.created_by }} - {{ moment(note.created_at).format('DD/MM/YYYY \à\\s HH:mm:ss') }}</span>
            <div class="form-control html-input" v-html="note.note ? note.note.replace(/\n/g, '<br>') : ''" type="text" disabled></div>
          </div>
        </div>
      </fieldset>
      <fieldset class="made-up avoid-page-break"
          v-if="this.getlogchat && this.getlogchat.attachments && this.getlogchat.attachments.length">
          <legend>Anexos</legend>
          <div class="attachments-container">
            <div class="composer-attachments"
              v-if="this.getlogchat.attachments && this.getlogchat.attachments?.length > 0">
              <ul>
                <li v-for="(attachment, attachIndex) in this.getlogchat.attachments" :key="attachIndex">
                  <span>
                    <i :class="getFileIcon(attachment.filename)"></i>
                    <span>{{ textSizeLimit(attachment.filename, 22) }}</span>
                    <small class="attachment-size">({{ formatFileSize(attachment.size) }})</small>
                  </span>
                  <a :href="attachment.download_url" :download="attachment.filename" class="download-attachment-btn"
                    title="Download anexo">
                    <i class="fas fa-download"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </fieldset>
        <fieldset class="made-up avoid-page-break" v-if="this.getlogchat.email_data">
          <legend>E-mails do Ticket</legend>

          <TicketEmailsViewer
            v-if="this.getlogchat.email_data.length"
            :emails="this.getlogchat.email_data"
            :primaryEmailId="this.getlogchat.primary_email_id"
            :showReplyButtons="true"
            :emailGroups="this.getlogchat.email_groups"
            :requestId="this.getlogchat._id"
            @emailSent="onTicketEmailSent"
            :solicitationData="getlogchat"
          />

          <div v-else class="no-emails-placeholder">
            <i class="fas fa-envelope-open no-emails-icon"></i>
            <p class="no-emails-label">Não há histórico de e-mails para esta solicitação.</p>
            <button class="btn-new-email" @click="openNewEmail()">
              <i class="fas fa-paper-plane"></i> Enviar e-mail
            </button>
          </div>
        
          <EmailNoReplyEditor
            ref="emailNoReplyEditorRef"
            v-if="newEmailVisible"
            :visible="newEmailVisible"
            :responseData="newEmailResponseData"
            :emailGroups="this.getlogchat.email_groups"
            @close="newEmailVisible = false"
            @emailSent="onNewEmailSent"
            @attachPdf="attachPdfToEmail"
            :solicitationData="getlogchat"
          />
        </fieldset>
        <fieldset class="made-up avoid-page-break" v-if="this.getlogchat && this.getlogchat.survey && Object.keys(this.getlogchat.survey).length">
          <legend>Pesquisa de Satisfação</legend>
          <div class="row">
            <div class="col-md-12" v-if="this.getlogchat.survey.avaliacao">
              <label for="userName"><strong>Avaliação</strong></label>
              <input class="form-control" v-model="this.getlogchat.survey.avaliacao" type="text" id="userName" name="userName" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.survey.reason">
              <label for="nomePonto"><strong>Razão da insatisfação</strong></label>
              <input class="form-control" v-model="this.getlogchat.survey.reason" type="text" id="nomePonto" name="nomePonto" disabled>
            </div>
          </div>
        </fieldset>
        <fieldset class="made-up avoid-page-break"
          v-if="this.getlogchat && this.getlogchat.log && this.getlogchat.log.length">
          <legend>Histórico de Atualizações</legend>
          <div class="notes-container">
            <div v-for="(myLog, logIndex) in getlogchat.log" :key="`${myLog.date}-${logIndex}`" class="note-item">
              <span>{{ myLog.event }} - {{ moment(myLog.date).format('DD/MM/YYYY \à\\s HH:mm:ss') }}</span>
              <div class="form-control html-input" v-html="myLog.description.replace(/\n/g, '<br>')" type="text" disabled></div>
            </div>
          </div>
        </fieldset>
        <fieldset class="made-up avoid-page-break">
          <legend>Adicionar anexos</legend>
          <div id="attach-wrapper">
            <div class="checkbox-group" @click="addAttach()">
              <span><i class="fas fa-paperclip"></i> Anexar Arquivos</span>
            </div>
            <div class="composer-attachments" v-if="attachments.length > 0">
              <h5>Anexos:</h5>
              <ul>
                <li v-for="(file, index) in attachments" :key="index">
                  <span>
                    <i :class="getFileIcon(file.name)"></i>
                    <span>{{ textSizeLimit(file.name, 22) }}</span>
                  </span>
                  <button @click="removeAttach(index)" class="remove-attachment-btn" title="Remover anexo">✕</button>
                </li>
              </ul>
            </div>
          </div>
        </fieldset>
      </div>

      <template #modal-footer>
        <div class="buttons-container">
          <div class="change-sector-container">
            <span>Área responsável: </span>
            <select v-model="sector" class="form-control">
              <option value="select" disabled>Selecione uma área responsável</option>
              <option value="">Não atribuído</option>
              <option>N1 - Atendimento a Clientes</option>
              <option>N2 - Suporte e Gestão de Serviços</option>
              <option>N2 - Gestão de Cofre Inteligente</option>
            </select>
          </div>
          <div class="change-sector-container">
            <span>Status: </span>
            <select v-model="status" class="form-control">
              <option value="" disabled>Selecione um status</option>
              <option>Aberto</option>
              <option>Em andamento</option>
              <option>Fechado</option>
            </select>
          </div>
          <div class="change-sector-container">
            <span>Desvio de procedimento: </span>
            <b-form-checkbox :key="deviationSwitchKey" switch :checked="hasProcedureDeviation" :disabled="savingDeviation" @change="onProcedureDeviationChange">
              {{ hasProcedureDeviation ? 'Sim' : 'Não' }}
            </b-form-checkbox>
            <b-button v-if="hasProcedureDeviation" variant="outline-secondary" size="sm" title="Ver/editar justificativa" @click="deviationModalShow = true">
              <i class="fas fa-edit"></i>
            </b-button>
          </div>
          <b-button variant="dark" @click="toggleNoteModal($event)">
            <i class="fas fa-sticky-note"></i>
            Adicionar anotação
          </b-button>
          <b-button v-if="!Object.keys(getlogchat.feedback).length && getlogchat.channel === 'Whatsapp'" variant="success"
            @click="toggleFeedbackModal($event)">
            <i class="fas fa-comment"></i>
            Enviar feedback
          </b-button>
          <b-button variant="primary" @click="downloadPdf()">
            <i class="fas fa-download"></i>
            Baixar PDF
          </b-button>
          <b-button v-if="attachments.length > 0" variant="success" @click="updateAttachments()">
            <i class="fas fa-download"></i>
            Enviar anexos
          </b-button>
        </div>
      </template>

      <VueHtml2pdf 
        class="d-none" 
        :show-layout="false" 
        :float-layout="true" 
        :enable-download="pdfMode === 'download'"
        :preview-modal="pdfMode === 'download'"
        :filename="filename" 
        :pdf-quality="2" 
        :manual-pagination="true" 
        pdf-format="a4"
        pdf-orientation="portrait" 
        ref="html2Pdf"
        @hasDownloaded="onPdfGenerated"
      >
        <section slot="pdf-content">
          <div class="modal-log pdf-wrapper">
            <fieldset 
              class="made-up" 
              v-if="
                this.getlogchat.type ||
                this.getlogchat.assunto ||
                this.getlogchat.motivo ||
                this.getlogchat.channel ||
                this.getlogchat.cidade ||
                this.getlogchat.solicitacaoData ||
                this.getlogchat.solicitacaoHora || 
                this.getlogchat.placa || 
                this.getlogchat.placaSolicitante || 
                this.getlogchat.prefixo || 
                this.getlogchat.sufixo || 
                this.getlogchat.nomeBase || 
                this.getlogchat.siglaBase || 
                this.getlogchat.solicitacaoAssunto || 
                this.getlogchat.solicitacaoTexto
              "
            >
              <legend>Solicitação</legend>
              <div class="row">
                <div class="col-md-12 espcForm" v-if="this.getlogchat.type">
                  <label for="type"><strong>Tipo</strong></label>
                  <input class="form-control" v-model="this.getlogchat.type" type="text" id="type" name="type" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.assunto">
                  <label for="assunto"><strong>Assunto</strong></label>
                  <input class="form-control" v-model="this.getlogchat.assunto" type="text" id="assunto" name="assunto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.motivo">
                  <label for="motivo"><strong>Motivo de Acionamento</strong></label>
                  <input class="form-control" v-model="this.getlogchat.motivo" type="text" id="motivo" name="motivo" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.channel">
                  <label for="channel"><strong>Canal de Atendimento</strong></label>
                  <input class="form-control" v-model="this.getlogchat.channel" type="text" id="channel" name="channel" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.solicitacaoData">
                  <label for="solicitacaoData"><strong>Data</strong></label>
                  <input class="form-control" v-model="this.getlogchat.solicitacaoData" type="text" id="solicitacaoData" name="solicitacaoData" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.solicitacaoHora">
                  <label for="solicitacaoHora"><strong>Hora</strong></label>
                  <input class="form-control" v-model="this.getlogchat.solicitacaoHora" type="text" id="solicitacaoHora" name="solicitacaoHora" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.placaSolicitante">
                  <label for="placaSolicitante"><strong>Placa do Solicitante</strong></label>
                  <input class="form-control" v-model="this.getlogchat.placaSolicitante" type="text" id="placaSolicitante" name="placaSolicitante" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.placa">
                  <label for="placa"><strong>Placa do veículo</strong></label>
                  <input class="form-control" v-model="this.getlogchat.placa" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.prefixo">
                  <label for="prefixo"><strong>Prefixo</strong></label>
                  <input class="form-control" v-model="this.getlogchat.prefixo" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.sufixo">
                  <label for="sufixo"><strong>Sufixo</strong></label>
                  <input class="form-control" v-model="this.getlogchat.sufixo" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.cidade">
                  <label for="cidade"><strong>Cidade</strong></label>
                  <input class="form-control" v-model="this.getlogchat.cidade" type="text" id="cidade" name="cidade" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.nomeBase">
                  <label for="nomeBase"><strong>Nome da Base</strong></label>
                  <input class="form-control" v-model="this.getlogchat.nomeBase" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.siglaBase">
                  <label for="siglaBase"><strong>Sigla da Base</strong></label>
                  <input class="form-control" v-model="this.getlogchat.siglaBase" type="text" id="solicitacaoAssunto" name="solicitacaoAssunto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.texto">
                  <label for="texto"><strong>Texto</strong></label>
                  <div v-html="getlogchat.texto" class="fixed-height-input" ></div>
                </div>
              </div>
            </fieldset>
            <fieldset 
              class="made-up" 
              v-if="
                this.getlogchat.nome || 
                this.getlogchat.contato || 
                this.getlogchat.cnpj || 
                this.getlogchat.protocolo || 
                this.getlogchat.assunto || 
                this.getlogchat.created_at || 
                this.getlogchat.created_by || 
                this.getlogchat.motivo ||
                this.getlogchat.sector ||
                this.getlogchat.sla ||
                this.getlogchat.sla_att 
              "
            >
              <legend>Dados do Atendimento</legend>
              <div class="row">
                <div class="col-md-12 espcForm" v-if="this.getlogchat.nome">
                  <label for="nome"><strong>Nome</strong></label>
                  <input class="form-control" v-model="this.getlogchat.nome" type="text" id="nome" name="nome" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.contato">
                  <label for="whatsapp"><strong>Telefone</strong></label>
                  <input class="form-control" v-model="this.getlogchat.contato" type="text" id="whatsapp" name="whatsapp" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.cnpj">
                  <label for="cnpj"><strong>CNPJ</strong></label>
                  <input class="form-control" v-model="this.getlogchat.cnpj" type="text" id="cnpj" name="cnpj" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.protocolo">
                  <label for="protocolo"><strong>Protocolo</strong></label>
                  <input class="form-control" v-model="this.getlogchat.protocolo" type="text" id="protocolo"
                    name="protocolo" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.sector">
                  <label for="sector"><strong>Área Responsável</strong></label>
                  <input class="form-control" v-model="this.getlogchat.sector" type="text" id="sector" name="sector"
                    disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.sla">
                  <label for="sla"><strong>SLA</strong></label>
                  <input class="form-control" v-model="this.getlogchat.sla" type="text" id="sla" name="sla"
                    disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.sla_att">
                  <label for="sla_att"><strong>Primeiro Atendimento</strong></label>
                  <input class="form-control" v-model="this.getlogchat.sla_att" type="text" id="sla_att" name="sla_att"
                    disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.created_at">
                  <label for="created_at"><strong>Data de Criação</strong></label>
                  <input class="form-control" v-model="this.getlogchat.created_at" type="text" id="created_at"
                    name="created_at" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.created_by">
                  <label for="created_by"><strong>Criado por</strong></label>
                  <input class="form-control" v-model="this.getlogchat.created_by" type="text" id="created_by"
                    name="created_by" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.updated_at">
                  <label for="updated_at"><strong>Data de Alteração</strong></label>
                  <input class="form-control" v-model="this.getlogchat.updated_at" type="text" id="updated_at"
                    name="updated_at" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.updated_by">
                  <label for="updated_by"><strong>Alterado por</strong></label>
                  <input class="form-control" v-model="this.getlogchat.updated_by" type="text" id="updated_by" name="updated_by" disabled>
                </div>    
              </div>
            </fieldset>
            <fieldset 
              class="made-up" 
              v-if="
                this.getlogchat.NomeCliente || 
                this.getlogchat.cnpj || 
                this.getlogchat.nomePonto || 
                this.getlogchat.codigoPonto || 
                this.getlogchat.endereco || 
                this.getlogchat.cep
              "
            >
              <legend>Dados da Base</legend>
              <div class="row">
                <div class="col-md-12 espcForm" v-if="this.getlogchat.NomeCliente">
                  <label for="NomeCliente"><strong>Cliente</strong></label>
                  <input class="form-control" v-model="this.getlogchat.NomeCliente" type="text" id="NomeCliente"
                    name="NomeCliente" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.nomePonto">
                  <label for="nomePonto"><strong>Nome do Ponto</strong></label>
                  <input class="form-control" v-model="this.getlogchat.nomePonto" type="text" id="nomePonto"
                    name="nomePonto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.codigoPonto">
                  <label for="codigoPonto"><strong>Código do Ponto</strong></label>
                  <input class="form-control" v-model="this.getlogchat.codigoPonto" type="text" id="codigoPonto"
                    name="codigoPonto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.Base">
                  <label for="base"><strong>Base</strong></label>
                  <input class="form-control" v-model="this.getlogchat.Base" type="text" id="base" name="base" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.endereco">
                  <label for="endereco"><strong>Endereço</strong></label>
                  <input class="form-control" v-model="this.getlogchat.endereco" type="text" id="endereco"
                    name="endereco" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.cep">
                  <label for="cep"><strong>CEP</strong></label>
                  <input class="form-control" v-model="this.getlogchat.cep" type="text" id="cep" name="cep" disabled>
                </div>
              </div>
            </fieldset>
            <fieldset class="made-up avoid-page-break" v-if="this.getlogchat && this.getlogchat.feedback && Object.keys(this.getlogchat.feedback).length">
              <legend>Feedback</legend>
              <div class="row">
                <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.updated_by">
                  <label for="userName"><strong>Enviado por</strong></label>
                  <input class="form-control" v-model="this.getlogchat.feedback.updated_by" type="text" id="userName"
                    name="userName" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.updated_at">
                  <label for="nomePonto"><strong>Data de envio</strong></label>
                  <input class="form-control" v-model="this.getlogchat.feedback.updated_at" type="text" id="nomePonto"
                    name="nomePonto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.message">
                  <label for="codigoPonto"><strong>Mensagem</strong></label>
                  <div class="form-control html-input" style="height: auto" v-html="this.getlogchat.feedback.message" type="text" disabled></div>
                </div>
              </div>
            </fieldset>

            <fieldset class="made-up avoid-page-break">
              <legend>Desvio de Procedimento</legend>
              <div class="row">
                <div class="col-md-12">
                  <label for="pdfProcedureDeviation"><strong>Houve desvio de procedimento?</strong></label>
                  <input class="form-control" :value="hasProcedureDeviation ? 'Sim' : 'Não'" type="text" id="pdfProcedureDeviation" disabled>
                </div>
                <template v-if="hasProcedureDeviation">
                  <div class="col-md-12 espcForm" v-if="getlogchat.procedure_deviation.updated_by">
                    <label for="pdfProcedureDeviationBy"><strong>Registrado por</strong></label>
                    <input class="form-control" :value="getlogchat.procedure_deviation.updated_by" type="text" id="pdfProcedureDeviationBy" disabled>
                  </div>
                  <div class="col-md-12 espcForm" v-if="getlogchat.procedure_deviation.updated_at">
                    <label for="pdfProcedureDeviationAt"><strong>Data do registro</strong></label>
                    <input class="form-control" :value="moment(getlogchat.procedure_deviation.updated_at).format('DD/MM/YYYY HH:mm:ss')" type="text" id="pdfProcedureDeviationAt" disabled>
                  </div>
                  <div class="col-md-12 espcForm">
                    <label for="pdfProcedureDeviationJustification"><strong>Justificativa</strong></label>
                    <div class="form-control html-input" id="pdfProcedureDeviationJustification" style="height: auto; white-space: pre-wrap; word-break: break-word;">{{ getlogchat.procedure_deviation.justification || '---' }}</div>
                  </div>
                </template>
              </div>
            </fieldset>

            <fieldset class="made-up avoid-page-break"
              v-if="this.getlogchat && this.getlogchat.notes && this.getlogchat.notes.length">
              <legend>Anotações</legend>
              <div class="notes-container">
                <div v-for="(note, noteIndex) in getlogchat.notes" :key="`${note.created_at}-${noteIndex}`" class="note-item">
                  <span>{{ note.created_by }} - {{ moment(note.created_at).format('DD/MM/YYYY \à\\s HH:mm:ss') }}</span>
                  <div class="form-control html-input" v-html="note.note.replace(/\n/g, '<br>')" type="text" disabled>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="made-up avoid-page-break"
              v-if="this.getlogchat && this.getlogchat.survey && Object.keys(this.getlogchat.survey).length">
              <legend>Pesquisa de Satisfação</legend>
              <div class="row">
                <div class="col-md-12" v-if="this.getlogchat.survey.avaliacao">
                  <label for="userName"><strong>Avaliação</strong></label>
                  <input class="form-control" v-model="this.getlogchat.survey.avaliacao" type="text" id="userName"
                    name="userName" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.survey.reason">
                  <label for="nomePonto"><strong>Razão da insatisfação</strong></label>
                  <input class="form-control" v-model="this.getlogchat.survey.reason" type="text" id="nomePonto"
                    name="nomePonto" disabled>
                </div>
              </div>
            </fieldset>

            <fieldset class="made-up avoid-page-break"
              v-if="this.getlogchat && this.getlogchat.log && this.getlogchat.log.length">
              <legend>Histórico de Atualizações</legend>
              <div class="notes-container">
                <div v-for="(myLog, logIndex) in getlogchat.log" :key="`${myLog.date}-${logIndex}`" class="note-item">
                  <span>{{ myLog.event }} - {{ moment(myLog.date).format('DD/MM/YYYY \à\\s HH:mm:ss') }}</span>
                  <div class="form-control html-input" v-html="myLog.description.replace(/\n/g, '<br>')" type="text" disabled></div>
                </div>
              </div>
            </fieldset>
          </div>
        </section>
      </VueHtml2pdf>
    </b-modal>

    <feedbackModal v-if="feedbackModalShow" :showModal="feedbackModalShow" @closeFeedbackModal="toggleFeedbackModal"
      :requirementInfo="requirementInfo"></feedbackModal>

    <noteModal v-if="noteModalShow" :showModal="noteModalShow" @closeNoteModal="toggleNoteModal"
      :requirementInfo="requirementInfo" :closeAfter="noteCloseAfter"></noteModal>

    <ProcedureDeviationModal v-if="deviationModalShow" :showModal="deviationModalShow"
      :requirementInfo="getlogchat" @closeDeviationModal="closeDeviationModal"></ProcedureDeviationModal>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';
import { handleSolicitationSLA } from "../../helpers/utils";
import TicketEmailsViewer from './TicketEmailsViewer.vue';
import EmailNoReplyEditor from '../emails/EmailNoReplyEditor.vue';
import ProcedureDeviationModal from './ProcedureDeviationModal.vue';

export default {
  components: {
    VueHtml2pdf,
    TicketEmailsViewer,
    EmailNoReplyEditor,
    ProcedureDeviationModal
  },
  data: () => ({
    ticketEmails: [],
    primaryEmailId: null,
    moment: moment,
    filename: '',
    feedbackModalShow: false,
    noteModalShow: false,
    requirementInfo: {},
    actAfterNote: null,
    noteCloseAfter: false,
    sector: '',
    status: '',
    sectorInitialized: false,
    statusInitialized: false,
    attachments: [],
    newEmailVisible: false,
    newEmailResponseData: null,
    noreplyEmails: null,
    pdfMode: 'download',
    deviationModalShow: false,
    savingDeviation: false,
    deviationSwitchKey: 0,
  }),
  computed: {
    ...mapGetters(['getlogchat']),
    hasProcedureDeviation() {
      return !!this.getlogchat?.procedure_deviation?.has_deviation;
    }
  },
  methods: {
    ...mapActions([
      "sendFeedbackMessage",
    ]),
    handleSolicitationSLA,
    async openModal() {
        this.$bvModal.show('details-modal');
        
        this.sector = this.getlogchat.sector;
        this.status = this.getlogchat.status;

        this.$nextTick(() => {
          this.sectorInitialized = true;
          this.statusInitialized = true;
        });

        this.filename = `solicitacao_${this.getlogchat.protocolo}_${moment().unix()}`
        if(this.getlogchat.texto){
          this.getlogchat.texto = this.getlogchat.texto.replaceAll('position: absolute; ', '')
          this.getlogchat.texto = this.getlogchat.texto.replaceAll('width: auto', 'width: 100%; margin-bottom: 5px')
        }
    },
    downloadPdf() {
      this.pdfMode = 'download';
      this.$nextTick(() => this.$refs.html2Pdf.generatePdf());
    },
    toggleFeedbackModal(data) {
      this.requirementInfo = this.getlogchat
      this.feedbackModalShow = !this.feedbackModalShow;
      if (data === 'saving') {
        this.$emit('reload', {item: this.getlogchat, reloadDetails: true})
      }
    },
    toggleNoteModal(data) {
      this.requirementInfo = this.getlogchat
      this.noteModalShow = !this.noteModalShow;
      this.noteCloseAfter = false;
      if (data === 'saving') {
        if (this.actAfterNote === 'status') {
          this.changeStatus();
        }
        
        this.actAfterNote = null;
        this.$emit('reload', {item: this.getlogchat, reloadDetails: true})
      }
    },
    onProcedureDeviationChange(checked) {
      if (checked) {
        // Só marca como SIM depois que a justificativa for salva no modal
        this.deviationModalShow = true;
        return;
      }
      this.removeProcedureDeviation();
    },
    closeDeviationModal(mode, data) {
      this.deviationModalShow = false;
      if (mode === 'saving' && data) {
        this.setProcedureDeviation(data);
        this.$emit('reload', {item: this.getlogchat, reloadDetails: true});
      }
      this.syncDeviationSwitch();
    },
    syncDeviationSwitch() {
      // Recria o switch para refletir o estado salvo (ex.: modal cancelado)
      this.deviationSwitchKey++;
    },
    setProcedureDeviation(data) {
      this.$set(this.getlogchat, 'procedure_deviation', {
        ...(this.getlogchat.procedure_deviation || {}),
        ...data,
      });
    },
    async removeProcedureDeviation() {
      const result = await Swal.fire({
        title: 'Remover desvio de procedimento?',
        text: 'A justificativa registrada será removida.',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover',
        cancelButtonText: 'Cancelar'
      });

      if (!result.value) {
        this.syncDeviationSwitch();
        return;
      }

      this.savingDeviation = true;
      try {
        const { data } = await axios.post('/solicitacoes/updateProcedureDeviation', {
          id: this.getlogchat.id,
          has_deviation: false,
        });

        if (data?.status !== 'success') throw new Error('Resposta inválida');

        this.setProcedureDeviation({ has_deviation: false, justification: null });
        this.$emit('reload', {item: this.getlogchat, reloadDetails: true});
        Swal.fire({
          type: 'success',
          text: 'Desvio de procedimento removido com sucesso!',
          timer: 2000,
          toast: true,
          showConfirmButton: false,
          position: 'top-end'
        });
      } catch (error) {
        console.error('Erro ao remover desvio de procedimento:', error);
        Swal.fire({
          type: 'error',
          title: 'Erro',
          text: 'Ocorreu um erro ao remover o desvio de procedimento'
        });
      } finally {
        this.savingDeviation = false;
        this.syncDeviationSwitch();
      }
    },
    changeSector() {
      try {
        axios.get(`/solicitacoes/changeSector/`, {
          params: {
            id: this.getlogchat.id,
            sector: this.sector
          }
        }).then(({ data }) => {
          if (data.status == 'success') {
            Swal.fire({
              type: "success",
              title: "Sucesso",
              text: "Área responsável atualizada com sucesso"
            });

            this.getlogchat.sector = this.sector
            this.$emit('reload', {item: this.getlogchat, reloadDetails: false})
          }
          else {
            Swal.fire({
              type: "error",
              title: "Error",
              text: "Ocorreu um erro ao atualizar a área responsável"
            });
          }
        });
      } catch (error) {
        Swal.fire({
          type: "error",
          title: "Error",
          text: "Ocorreu um erro ao atualizar a área responsável"
        });
      }
    },
    async changeStatus() {
      const payload = {
        status: this.status,
        old_status: this.getlogchat.status,
        solicitationId: this.getlogchat.id,
        updatedBy: user.getName(),
        type: 'relato'
      };
    
      axios.post('/solicitacoes/changeStatusMongo', payload).then(async ({ data }) => {
        if (data.status === 'success') {
          Swal.fire({
            type:  'success',
            title: 'Sucesso',
            text:  'Status atualizado com sucesso'
          });

          let event;
          const currentStatus = this.getlogchat.status.toLowerCase();
          const newStatus = this.status.toLowerCase();
        
          this.getlogchat.status = this.status;

          if (['fechado'].includes(currentStatus) && ['em andamento', 'aberto'].includes(newStatus)) {
            event = 'request_reopened';
          } else if (currentStatus === 'aberto' && newStatus === 'em andamento') {
            event = 'request_in_progress';
          } else if (newStatus === 'fechado') {
            event = 'request_closed';
          } else {
            event = 'request_created';
          }
        
          const notification = await this.getNotificationsConfig(event);
        
          if (notification?.active && notification?.groups?.length) {
            await this.sendNotifications(notification.groups, event);
          }

          this.$emit('reload', { item: this.getlogchat, reloadDetails: true });
        } else {
          Swal.fire({
            type:  'error',
            title: 'Erro',
            text:  'Ocorreu um erro ao atualizar o status'
          });
        }
      });
    },
    getFileIcon(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      const iconMap = {
        'jpg': 'fas fa-file-image',
        'jpeg': 'fas fa-file-image',
        'png': 'fas fa-file-image',
        'gif': 'fas fa-file-image',
        'bmp': 'fas fa-file-image',
        'svg': 'fas fa-file-image',
        'pdf': 'fas fa-file-pdf',
        'doc': 'fas fa-file-word',
        'docx': 'fas fa-file-word',
        'xls': 'fas fa-file-excel',
        'xlsx': 'fas fa-file-excel',
        'ppt': 'fas fa-file-powerpoint',
        'pptx': 'fas fa-file-powerpoint',
        'txt': 'fas fa-file-alt',
        'mp3': 'fas fa-file-audio',
        'wav': 'fas fa-file-audio',
        'ogg': 'fas fa-file-audio',
        'mp4': 'fas fa-file-video',
        'avi': 'fas fa-file-video',
        'mov': 'fas fa-file-video',
        'mkv': 'fas fa-file-video',
        'zip': 'fas fa-file-archive',
        'rar': 'fas fa-file-archive',
        '7z': 'fas fa-file-archive',
        'html': 'fas fa-file-code',
        'css': 'fas fa-file-code',
        'js': 'fas fa-file-code',
        'json': 'fas fa-file-code',
        'xml': 'fas fa-file-code',
        'php': 'fas fa-file-code',
        'py': 'fas fa-file-code',
        default: 'fas fa-file-alt'
      };

      return iconMap[extension] || iconMap.default;
    },
    textSizeLimit(text = "", size = 100) {
      if (typeof text != "string" || typeof size != "number") return text;
      const pontoIndex = text.lastIndexOf('.');

      if (pontoIndex === -1) {
        return text.substring(0, size);
      }

      const extensao = text.substring(pontoIndex);
      const nome = text.substring(0, pontoIndex);
      const tamanhoDisponivel = size - extensao.length;

      if (tamanhoDisponivel <= 0) {
        return extensao.substring(0, size);
      }

      return nome.substring(0, tamanhoDisponivel) + extensao;
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    addAttach() {
      if (this.attachments.length >= 10) {
        Swal.fire({
          title: 'Limite de arquivos excedido',
          text: 'É possível anexar no máximo 10 arquivos.',
          type: 'warning',
          confirmButtonText: 'OK'
        });
        return;
      }

      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = true;
      input.onchange = (e) => {
        const files = Array.from(e.target.files);
        const remainingSlots = 10 - this.attachments.length;

        if (files.length > remainingSlots) {
          Swal.fire({
            title: 'Limite de arquivos excedido',
            text: `É possível anexar no máximo 10 arquivos.`,
            type: 'warning',
            confirmButtonText: 'OK'
          });
          this.attachments = [...this.attachments, ...files.slice(0, remainingSlots)];
        } else {
          this.attachments = [...this.attachments, ...files];
        }
      };
      input.click();
    },
    removeAttach(index) {
      this.attachments.splice(index, 1);
    },
    updateAttachments() {
      const formData = new FormData();
      this.attachments.forEach((file) => {
        formData.append('attachments[]', file);
      });

      axios.post(`solicitacoes/updateAttachmentsRequest/${this.getlogchat.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        Swal.fire({
          type: 'success',
          text: 'Anexos enviados com sucesso!',
          timer: 2000,
          toast: true,
          showConfirmButton: false,
          position: 'top-end'
        });
        this.attachments = [];
        this.$emit('reload', {item: this.getlogchat, reloadDetails: true})
      })
    },
    onTicketEmailSent(data) {
      if (data?.email?.id) {
        this.getlogchat.email_data.push(data.email);
      }

      if(this.getlogchat.status !== 'Fechado'){
        Swal.fire({
          title: 'E-mail enviado!',
          text: 'Deseja encerrar a solicitação?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, encerrar',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result.value) {
            this.status = 'Fechado';
          }
        });
      }
    },
    openNewEmail() {
      this.newEmailResponseData = {
        from_email: '',
        to_email:   [],
        copy_email: [],
        subject_email: this.getlogchat.protocolo
          ? `Solicitação #${this.getlogchat.protocolo}`
          : '',
        ticket_id: null,
        protocol:  this.getlogchat.protocolo ?? null,
        in_reply_to:  '',
        references:   null,
        thread_index: null,
        reply_email:  null,
        is_received:  false,
        request_id: this.getlogchat._id
      };
      this.newEmailVisible = true;
    },
    onNewEmailSent(data) {
      this.newEmailVisible = false;
      if (data?.email?.id) {
        if (!this.getlogchat.email_data) {
          this.getlogchat.email_data = [];
        }
        this.getlogchat.email_data.push(data.email);
      }

      if(this.getlogchat.status !== 'Fechado'){
        Swal.fire({
          title: 'E-mail enviado!',
          text: 'Deseja encerrar a solicitação?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, encerrar',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result.value) {
            this.status = 'Fechado';
          }
        });
      }
    },
    attachPdfToEmail() {
      this.pdfMode = 'attach';
      this.$nextTick(() => this.$refs.html2Pdf.generatePdf());
    },
    onPdfGenerated(blob) {
      if (this.pdfMode !== 'attach') return;
      const file = new File([blob], `${this.filename}.pdf`, { type: 'application/pdf' });
      this.$refs.emailNoReplyEditorRef?.addAttachment(file);
      this.pdfMode = 'download';
    },

    buildEmailNotificationBody(event, reason = null) {
      const chamado  = this.getlogchat.chamado;
      const protocol = this.getlogchat.protocol || this.getlogchat.protocolo;
      const userName = user.getName();

      let actionText;
      if (event === 'request_created')     actionText = `foi <strong>criada</strong> pelo usuário ${userName}.`;
      else if (event === 'request_in_progress') actionText = `está <strong>em andamento</strong> pelo usuário ${userName}.`;
      else if (event === 'request_closed') actionText = `foi <strong>fechada</strong> pelo usuário ${userName}.`;
      else if (event === 'request_reopened') {
        actionText = `foi <strong>reaberta</strong> pelo usuário ${userName}.`;
        if (reason) actionText += ` Motivo: ${reason}`;
      } else {
        actionText = `foi atualizada pelo usuário ${userName}.`;
      }

      return `
        <p>🔔 <strong>Notificação de Solicitação</strong></p>
        <p>
          A solicitação do chamado <strong>${chamado}</strong>
          ${protocol ? `referente ao protocolo <strong>${protocol}</strong>` : ''}
          ${actionText}
        </p>
        <hr>
        <p><strong>Dados da solicitação</strong></p>
        <p>#️⃣ <strong>Chamado:</strong> ${chamado}</p>
        <p>#️⃣ <strong>Protocolo do atendimento:</strong> ${protocol || "---"}</p>
        <p>👤 <strong>Solicitante:</strong> ${this.getlogchat.nome}</p>
        <p>🏢 <strong>Ponto:</strong> ${this.getlogchat.nomePonto || '---'}</p>
        <p>🪪 <strong>CNPJ:</strong> ${this.getlogchat.cnpj || '---'}</p>
        <p>📖 <strong>Motivo:</strong> ${this.getlogchat.motivo}</p>
        <hr>
        <small><em>Esta é uma mensagem automática. Para parar de receber estas mensagens, entre em contato com o suporte.</em></small>
      `;
    },

    async resolveNoreplyFrom(preferredFrom = null) {
      // Notificações são sempre enviadas por uma caixa no-reply ativa
      if (!this.noreplyEmails) {
        try {
          const { data } = await axios.get('/emails/config/noreply');
          this.noreplyEmails = Array.isArray(data) ? data : [];
        } catch (error) {
          console.error('Erro ao buscar caixas no-reply:', error);
          return null;
        }
      }

      if (preferredFrom && this.noreplyEmails.some(config => config.email_address === preferredFrom)) {
        return preferredFrom;
      }
      return this.noreplyEmails[0]?.email_address ?? null;
    },

    async sendEmailNotification(group, event, reason = null) {
      if (!group.contacts?.length) return;

      const chamado  = this.getlogchat.chamado;
      const protocol = this.getlogchat.protocol || this.getlogchat.protocolo;

      const subject = protocol
        ? `[Notificação] Chamado ${chamado} – Protocolo ${protocol}`
        : `[Notificação] Chamado ${chamado}`;

      const body = this.buildEmailNotificationBody(event, reason);

      const toEmails = group.contacts
        .map(c => (c.contact || '').trim())
        .filter(Boolean);

      if (!toEmails.length) return;

      const from = await this.resolveNoreplyFrom(this.$refs.emailNoReplyEditorRef?.email?.from);
      if (!from) {
        console.warn('Nenhuma caixa de e-mail no-reply ativa para enviar a notificação.');
        return;
      }

      const formData = new FormData();

      toEmails.forEach(email => formData.append('to[]', email));
      formData.append('from',           from);
      formData.append('is_noreply',     true);
      formData.append('subject',        subject);
      formData.append('body',           body);
      formData.append('ticket_id',      this.getlogchat.ticket_id ?? '');
      formData.append('request_id',     this.getlogchat._id ?? '');
      formData.append('in_reply_to',    '');
      formData.append('references',     '');
      formData.append('thread_index',   '');
      formData.append('reply_email',    JSON.stringify(null));
      formData.append('ticket_protocol', this.getlogchat.protocolo ?? '');

      await axios.post('/emails/send', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    },

    async sendNotifications(groups, event, reason = null) {
      Swal.fire({
        showConfirmButton: false,
        html: `<div>
                 <i class="fas fa-spinner fa-pulse"></i><br>
                 <span><b>Enviando notificações</b><br>Por favor, aguarde...</span>
               </div>`,
        allowOutsideClick: false,
      });
    
      try {
        const chamado  = this.getlogchat.chamado;
        const protocol = this.getlogchat.protocol || this.getlogchat.protocolo;
        const userName = user.getName();
      
        let base = `🔔 Notificação de Solicitação\n\nA solicitação do chamado *${chamado}*`;
        if (protocol) base += ` referente ao protocolo *${protocol}*`;
      
        let whatsappMsg;
        if (event === 'request_created') whatsappMsg = `${base} foi *criada* pelo usuário ${userName}.`;
        else if (event === 'request_in_progress') whatsappMsg = `${base} está *em andamento* pelo usuário ${userName}.`;
        else if (event === 'request_closed')  whatsappMsg = `${base} foi *fechada* pelo usuário ${userName}.`;
        else if (event === 'request_reopened') {
          whatsappMsg = `${base} foi *reaberta* pelo usuário ${userName}.`;
          if (reason) whatsappMsg += `. Motivo: ${reason}`;
        } else {
          whatsappMsg = base;
        }

        whatsappMsg += `\n\n*Dados da solicitação*\n#️⃣ *Chamado*: ${chamado}\n🔢 *Protocolo do atendimento*: ${protocol || "---"}\n👤 *Solicitante*: ${this.getlogchat.nome}\n🏢 *Ponto*: ${this.getlogchat.nomePonto || '---'}\n🪪 *CNPJ*: ${this.getlogchat.cnpj || '---'}\n📖 *Motivo*: ${this.getlogchat.motivo}\n\n_Esta é uma mensagem automática. Para parar de receber estas mensagens, entre em contato com o suporte._\n`;

        for (const group of groups) {
          if (!group.contacts?.length) continue;

          if (group.type === 'whatsapp') {
            for (const contact of group.contacts) {
              const obj = {
                client_id:      `55${contact.contact}@s.whatsapp.net`,
                message:        whatsappMsg,
                requirement_id: this.getlogchat.id,
                protocol:       chamado,
                notification:   true,
              };
              await this.sendFeedbackMessage(obj);
            }

          } else if (group.type === 'email') {
            await this.sendEmailNotification(group, event, reason);
          }
        }

      } catch (error) {
        console.error('Erro ao enviar notificações:', error);
      } finally {
        Swal.close();
      }
    },

    async getNotificationsConfig(event) {
      try {
        const { data } = await axios.get(`/solicitacoes/notifications/event/${event}`);
        return data;
      } catch (error) {
        if (error.response?.status !== 404) {
          console.error('Erro ao buscar configuração de notificação:', error);
        }
        return null;
      }
    },
  },

  watch: {
    sector(newVal) {
      if (!this.sectorInitialized) return;

      if (newVal !== this.getlogchat.sector) {
        const name = newVal !== '' ? newVal : 'Não atribuído'
        Swal.fire({
          title: 'Alteração de Área Responsável',
          text: `Deseja alterar a área responsável para "${name}"?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result.value) {
            this.changeSector();
          } else {
            this.sector = this.getlogchat.sector;
          }
        });
      }
    },
    status(newVal) {
      if (!this.statusInitialized) return;

      if (newVal !== this.getlogchat.status) {
        Swal.fire({
          title: 'Alteração de Status',
          html: `<p>Deseja alterar o status para "${newVal}"?</p>
          <p><strong>Obs: </strong>Para fechar ou reabrir a solicitação, é necessário adicionar um comentário!</p>`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result?.value) {
            if(this.getlogchat.status.toLowerCase() == 'aberto' && newVal.toLowerCase().includes('andamento')){
              this.changeStatus();
            } else {
              this.actAfterNote = "status";
              this.requirementInfo = this.getlogchat;
              this.noteCloseAfter = true;           
              this.noteModalShow = true;
              return; 
            }
            this.actAfterNote = null;
            this.noteCloseAfter = false;
          } else {
            this.status = this.getlogchat.status;
          }
        });
      }
    },
  }
}
</script>

<style scoped lang="scss">
.modal-log {
  overflow-y: auto;
  overflow-x: hidden;
}

.modal-log .espcForm {
  margin: 5px 0px 0px 0px;
}

.modal-log label,
input,
textarea {
  font-size: 12px;
}

.made-up {
  font-family: arial;
  margin: 10px;
  border-radius: 10px;
  background: #fff;
  border: solid 1px #9797A6;
  border-radius: 2px;
  padding: 10px;
}

.made-up fieldset {
  margin: 5px 30px;
}

fieldset {
  page-break-inside: avoid;
  break-inside: avoid;
}

.pdf-wrapper {
  page-break-before: auto;
  page-break-after: auto;
}

.made-up legend {
  background: #1C869A;
  color: #FEFEFE;
  margin: 0px;
  padding: 5px 20px;
  width: auto;
  font-size: 14px;
  border-radius: 2px;
}

.avoid-page-break {
  page-break-inside: avoid;
}

textarea {
  display: inline-block;
  width: 100%;
  padding: 0px 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.textoPDF {
  display: inline-block;
  width: 100%;
  padding: 0px 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.buttons-container {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 30px;

  button {
    font-size: small;
    padding: 5px;
    border-radius: 5px !important;
  }

  .change-sector-container {
    display: flex;
    align-items: center;
    gap: 5px;

    span {
      font-weight: bold;
      white-space: nowrap;
    }

    select {
      font-size: small;
      cursor: pointer;
      border-radius: 10px !important;
    }
  }
}

.fixed-height-input {
  height: 200px; 
  max-height: 200px; 
  overflow: auto; 
  border: 1px solid lightgray; 
  background-color: #e9ecef;
  white-space: pre-line;
}

.variable-height-input {
  height: auto;
  background-color: #e9ecef;
  border: 1px solid lightgray;
  font-size: smaller;
}

.html-input {
  height: auto;
  background-color: #e9ecef;
  font-size: smaller;
  white-space: pre-line;
  word-wrap: break-word;
  padding: 5px;
}

.notes-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.note-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
  border: 1px solid lightgray;
  padding: 10px;
  border-radius: 5px;

  span {
    background-color: #1c869a;
    color: white;
    font-weight: bold;
    padding-left: 5px;
  }
}

.composer-attachments {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.composer-attachments>h5 {
  font-size: 13px;
  margin: 0 0 10px 0;
}

.composer-attachments>ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.composer-attachments>ul>li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #f1f1f1;
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 12px;
  border: 1px solid #9797A6
}

.composer-attachments>ul>li>span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.checkbox-group {
  display: flex;
  gap: 5px;
  width: 150px;
  margin: 10px 0px;
  padding: 2px 10px;
  height: fit-content;
  align-self: end;
  cursor: pointer;
  border: 1px solid #ededed;
  border-radius: 10px;
  box-shadow: 1px 1px 2px 0px lightgray;
  transition: ease-in-out 0.2s;

  span {
    white-space: nowrap;
    align-content: center;
    font-weight: bold;
  }

  &:hover {
    background-color: #ededed;
  }
}

.remove-attachment-btn {
  background: none;
  border: none;
  color: #dc3545;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
  padding: 0 5px;
}

.no-emails-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  gap: 12px;
  text-align: center;
}

.no-emails-icon {
  font-size: 36px;
  color: #b0c4c4;
}

.no-emails-label {
  font-size: 13px;
  color: #888;
  margin: 0;
}

.btn-new-email {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #2e8b8b, #4a9a9a);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(46, 139, 139, 0.25);
}

.btn-new-email:hover {
  background: linear-gradient(135deg, #256f6f, #2e8b8b);
  box-shadow: 0 4px 14px rgba(46, 139, 139, 0.35);
  transform: translateY(-1px);
}
</style>